import {get, post} from "../APIGateWay";

export async function getAssignments(data) {
    return await post(data, '/assignment/list')
}
